import React from 'react';
import { Box, Typography } from '@material-ui/core';
import {
  QueueStatusCell,
  QueueActionCell,
  QueueSelectCell,
} from '../components/queue-row-cells/queue-row-cells';
import SuggestedMatchCell from '../components/suggested-match-cell/suggested-match-cell';
import { formatQueuedAt, isLinkableWithSuggestion } from './lms-course-review.utils';

const CourseNameCell = ({ name, canvasId }) => (
  <Box>
    <Typography variant="body2">{name}</Typography>
    {canvasId ? (
      <Typography variant="caption" color="textSecondary" display="block">
        {canvasId}
      </Typography>
    ) : null}
  </Box>
);

/**
 * Map queue items to DataGrid row format.
 * @param {Array} items - Queue items from API
 * @param {Function} onOpenResolution - Callback when resolution dialog should open
 * @param {Set} selectedIds - Selected catalog ids
 * @param {Function} [onToggleSelect] - Toggle row selection (parent-controlled checkboxes)
 * @returns {Array} Grid rows
 */
export const mapQueueItemsToGridRows = (
  items,
  onOpenResolution,
  selectedIds = new Set(),
  onToggleSelect = null,
  onInlineAccept = null
) =>
  items.map((item) => ({
    isSelected: selectedIds.has(item.id),
    rowData: {
      id: item.id,
      select: () => (
        <QueueSelectCell
          checked={selectedIds.has(item.id)}
          disabled={!isLinkableWithSuggestion(item)}
          onToggle={() => onToggleSelect?.(item.id)}
        />
      ),
      canvasCourseName: () => (
        <CourseNameCell name={item.canvasCourseName} canvasId={item.canvasCourseId} />
      ),
      canvasCourseId: item.canvasCourseId,
      queuedAt: formatQueuedAt(item.queuedAt),
      status: () => <QueueStatusCell item={item} />,
      suggestedMatch: () => <SuggestedMatchCell item={item} />,
      linkedResourceId:
        item.linkedResourceId != null ? String(item.linkedResourceId) : '—',
      actions: () => (
        <QueueActionCell
          item={item}
          onOpenResolution={onOpenResolution}
          onInlineAccept={onInlineAccept}
        />
      ),
    },
  }));
